<template>
    <div class="progress">
        <div class="progress-point">
          <div class="progress-point-list">
            <div class="progress-point-list-num">
              <div class="progress-point-list-num-back point-active">1</div>
            </div>
            <div class="progress-point-list-text">填写申报材料</div>
          </div>
          <div class="progress-point-list">
            <div class="progress-point-list-num">
              <div class="progress-point-list-num-back" :class="{'point-active':status>0}">2</div>
            </div>
            <div class="progress-point-list-text">等待审核</div>
          </div>
          <div class="progress-point-list">
            <div class="progress-point-list-num">
              <div class="progress-point-list-num-back" :class="{'point-active':status>2}">3</div>
            </div>
            <div class="progress-point-list-text">具备领取资格</div>
          </div>
        </div>
        <div class="progress-line"></div>
    </div>
</template>
<script>
export default {
  props: ['status']
}
</script>
<style lang="scss" scoped>
.progress {
    background: #fff;
    padding:10px 0;
    .progress-point{
        display:flex;
        position:relative;
        z-index:10;
        &-list{
            flex:1;
            text-align:center;
            &-num{
                display:inline-block;
                background:#fff;
                padding:15px 6px 10px;
                &-back{
                    width:24px;
                    height:24px;
                    text-align:center;
                    line-height:24px;
                    background:#D3DFF8;
                    color:#fff;
                    font-size:14px;
                    font-weight:bold;
                    border-radius:50%;
                }
                .point-active{
                    background:#0080FF;
                    box-shadow: 0 0 6px rgba(0, 128, 255, 0.8);
                }
            }
            &-text{
                font-size:14px;
            }
        }
    }
    .progress-line{
        width:60%;
        height:1px;
        border-bottom: 1px solid #D3DFF8;
        position:relative;
        left:20%;
        top:-42px;
    }
  }
</style>
